<template>
  <generic-container
    :title="$t('modifiers')"
    icon="code"
    :show_plus="true"
    :searchable="true"
    style="margin-top:15px"
    @add="add"
    @filter="filter"
  >
    <div class="ui selection divided list">
      <div
        class="item"
        v-for="(item, index) in human_task.modifiers"
        :key="index"
        v-on:click="edit(item, index)"
      >
        <div class="right floated buttons">
          <div
            class="ui button red icon mini labeled"
            v-on:click.stop="remove(item, index)"
          >
            <i class="trash icon"></i>
            {{ $t("delete") }}
          </div>
        </div>
        <img
          class="ui avatar image"
          :src="'/images/icons/' + item.type + '.png'"
        />
        <div class="content">
          <a class="header">{{ item.name }}</a>
          <div class="description">{{ item.description }}</div>
        </div>
      </div>
    </div>
    <template v-for="(mdl, index) in popup_modals">
      <component
        :is="mdl"
        :key="index"
        :modifier="selected_modifier"
        v-on:destroy="destroy"
        v-on:succedded="succedded"
      ></component>
    </template>
  </generic-container>
</template>

<script>
import GenericContainer from "@/components/GenericContainer";
import ModifierModal from "./ModifierModal";
import filters from "@/filters";

export default {
  name: "HumanTaskManagement",
  filters: filters,
  props: { human_task: Object },
  components: {
    GenericContainer
  },
  data() {
    return {
      popup_modals: [],
      selected_modifier: {}
    };
  },
  methods: {
    edit(modifier) {
      this.selected_modifier = modifier;
      this.popup_modals.push(ModifierModal);
    },
    remove(modifier, index) {
      this.human_task.modifiers.splice(index, 1);
    },
    add() {
      this.popup_modals.push(ModifierModal);
    },
    succedded(mf) {
      let vm = this;
      let trgt = vm.human_task.modifiers.findIndex((n) => n.uuid == mf.uuid);
      if (trgt != -1) vm.human_task.modifiers.splice(trgt, 1, mf);
      else vm.human_task.modifiers.push(mf);
    },
    destroy() {
      this.popup_modals = [];
      this.selected_modifier = {};
    },
    filter(query) {
      console.log(query);
    }
  },
  mounted() {},
  watch: {}
};
</script>
